module.exports = __webpack_public_path__ + "img/hr-tree-07-c-leaves.145ccbff.png";